
import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import RegistryAccount from "../../components/admin/RegistryAccount";

const AdminRegistry: React.FC = () => {
  return (
    <MainLayout>
      <RegistryAccount />
    </MainLayout>
  );
};

export default AdminRegistry;
